import React from 'react';
interface PlayerTimerProps {
  remaining: number;
  paused?: boolean;
}
function format(seconds: number): string {
  const clamped = Math.max(0, Math.ceil(seconds - 0.0001));
  const minutes = Math.floor(clamped / 60);
  const rest = clamped % 60;
  return `${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
}

/** Player-style clock: large, monospaced digits in the corner of the canvas. */
export function PlayerTimer({
  remaining,
  paused = false
}: PlayerTimerProps) {
  return <div className="pointer-events-none absolute right-4 top-3 z-10 md:right-7 md:top-5" role="timer" aria-label={`${Math.max(0, Math.ceil(remaining))} seconds left`} data-id="element-162" data-mp="17rz0ccuxo5ub">
      <span className={`font-headline text-3xl font-extrabold tabular-nums tracking-tight transition-colors duration-150 ease-out md:text-5xl ${paused ? 'text-solventum-primary/50' : 'text-solventum-primary'}`} data-id="element-163" data-mp="ysbzbs64921s">
        {format(remaining)}
      </span>
    </div>;
}